import styled, { css } from 'styled-components'
import { themeColor } from 'LibNeo'

interface ComponentProps {
	isShow: boolean
}

interface ScrollProps {
	hasScroll?: boolean
	isStartScroll?: boolean
}

export const Filters = styled.div<ComponentProps & Pick<ScrollProps, 'hasScroll'>>`
	height: 100%;
	overflow: auto;
	background: ${themeColor('white')};
	border: 1px solid ${themeColor('gray', 3)};
	border-radius: 6px;
	transform: translateX(${({ isShow }) => (isShow ? '0' : '1000%')});
	transition: 0.3s;
	position: relative;
	-ms-overflow-style: none;
	scrollbar-width: none;

	&:after {
		display: ${({ hasScroll }) => (hasScroll ? 'flex' : 'none')};
		content: '';
		background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 54.17%);
		height: 60px;
		position: sticky;
		bottom: 0;
		z-index: 100;
		width: 100%;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`

export const FiltersContent = styled.div<Pick<ScrollProps, 'hasScroll'>>`
	padding: 20px;
	margin-bottom: ${({ hasScroll }) => (hasScroll ? '340px' : 0)};
`

export const FiltersHeader = styled.div<Pick<ScrollProps, 'isStartScroll'>>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	position: sticky;
	top: 0;
	z-index: 100;
	background: ${themeColor('white')};
	border-bottom: 1px solid ${themeColor('gray', 3)};

	${({ isStartScroll }) =>
		isStartScroll &&
		css`
			box-shadow: 0 4px 16px -2px rgba(0, 0, 0, 0.15);
		`}
`

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 20px;
`

export const TitleWrapper = styled.div`
	display: flex;
	gap: 8px;
`

export const WrapperBlockFilterStyled = styled.div<{ marginLeft?: number }>`
	width: 600px;
	min-width: 600px;
	margin-left: ${({ marginLeft = 0 }) => `${marginLeft}px`};
	@media (max-width: 1440px) {
		width: 400px;
		min-width: 400px;
	}
`
